var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasksViewEntries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fee471;}.cls-2{fill:#784ace;}.cls-3{fill:#00dbd5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.09,
    y: 77.81,
    width: 433.21,
    height: 521.26,
    rx: 22.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.21,
    y: 321.46,
    width: 296.03,
    height: 61.81,
    rx: 30.91,
    transform: "translate(2.66 -2.23) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.26,
    y: 445.09,
    width: 296.03,
    height: 61.81,
    rx: 30.91,
    transform: "translate(3.58 -2.22) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151.15,
    y: 197.83,
    width: 295.17,
    height: 61.81,
    rx: 30.91,
    transform: "translate(1.73 -2.24) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 202.69,
    y: 49.32,
    width: 192.02,
    height: 62.01,
    rx: 31.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.5,30.1a20.23,20.23,0,1,1-20.22,20.22A20.24,20.24,0,0,1,300.5,30.1m0-30a50.23,50.23,0,1,0,50.22,50.22A50.23,50.23,0,0,0,300.5.1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksViewEntries);
export default __webpack_public_path__ + "static/media/tasks_view_entries.3152552dbd12e9874cdaa1f49d07b86b.svg";
export { ForwardRef as ReactComponent };